// import React, { useEffect, useState } from 'react';
// import styles from "../../assets/scss/InventoryManagement/AddItemsPopup.module.scss";
// import { useGetItemBagsQuery, useGetItemcatQuery } from '../../slices/admin/admin';

// const AddItemsPopup = ({ onClose, isEditMode = false, itemData = null }) => {
//     const [itemImage, setItemImage] = useState(null);
//     const [formData, setFormData] = useState({
//         category: '',
//         description: '',
//         bag: '',
//         quantityLevel: '',
//         quality: '',
//         quantity: '',
//         count: ''
//     });

//     const [errors, setErrors] = useState({});
//     const { data: bagData } = useGetItemBagsQuery();
//     const { data: catData } = useGetItemcatQuery();

//     useEffect(() => {
//         if (itemData) {
//             setFormData({
//                 category: itemData.category || '',
//                 description: itemData.description || '',
//                 bag: itemData.bag || '',
//                 quantityLevel: itemData.quantityLevel || '',
//                 quality: itemData.quality || '',
//                 quantity: itemData.quantity || '',
//                 count: itemData.count || ''
//             });
//         }
//     }, [itemData]);

//     const handleImageChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setItemImage(URL.createObjectURL(file));
//         }
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const validate = () => {
//         const newErrors = {};

//         if (!formData.category) newErrors.category = 'Category is required';
//        //if (!formData.description) newErrors.description = 'Description is required';
//         if (!formData.bag) newErrors.bag = 'Bag is required';
//         if (!formData.quantityLevel) newErrors.quantityLevel = 'Quantity Level is required';

//         if (formData.bag === 'kilogram') {
//             if (!formData.quantity) newErrors.quantity = 'Quantity is required';
//         } else {
//             if (!formData.count) newErrors.count = 'Count is required';
//         }

//         return newErrors;
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         const validationErrors = validate();
//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             return;
//         }

//         const storedItems = JSON.parse(localStorage.getItem('inventoryItems') || '[]');

//         if (isEditMode && itemData?._id) {
//             const updatedItems = storedItems.map(item =>
//                 item._id === itemData._id ? { ...formData, _id: itemData._id } : item
//             );
//             localStorage.setItem('inventoryItems', JSON.stringify(updatedItems));
//         } else {
//             const newItem = { ...formData, _id: new Date().getTime().toString() };
//             localStorage.setItem('inventoryItems', JSON.stringify([...storedItems, newItem]));
//         }

//         onClose();
//     };

//     return (
//         <div className={styles.createOrdersContainers}>
//             <div className={styles.header}>
//                 <h2 className={styles.tittle}>{isEditMode ? "Edit Item" : "Add Item"}</h2>
//                 <span className={styles.closeIcon} onClick={onClose}>✕</span>
//             </div>

//             <form className={styles.formContainer} onSubmit={handleSubmit}>
//                 <div className={styles.row}>
//                     <div className={styles.inputGroup}>
//                         <label className={styles.inputLabel}>Item Category</label>
//                         <select
//                             name="category"
//                             className={styles.inputs}
//                             value={formData.category}
//                             onChange={handleChange}
//                         >
//                             <option value="">Select Category</option>
//                             {(catData?.getAllItems || []).map(cat => (
//                                 <option key={cat._id} value={cat.itemCategory}>
//                                     {cat.itemCategory}
//                                 </option>
//                             ))}
//                         </select>
//                         {errors.category && <span className={styles.error}>{errors.category}</span>}
//                     </div>

//                     {/* <div className={styles.inputGroup}>
//                         <label className={styles.inputLabel}>Item Descriptions</label>
//                         <input
//                             name="description"
//                             className={styles.input}
//                             type="text"
//                             placeholder="Item Description"
//                             value={formData.description}
//                             onChange={handleChange}
//                         />
//                         {errors.description && <span className={styles.error}>{errors.description}</span>}
//                     </div> */}
//                        <div className={styles.inputGroup}>
//                         <label className={styles.inputLabel}>Item Scales</label>
//                         <select
//                             name="bag"
//                             className={styles.inputs}
//                             value={formData.bag}
//                             onChange={handleChange}
//                         >
//                             <option value="">Select Bag</option>
//                             {(bagData?.itemBags || []).map(bag => (
//                                 <option key={bag._id} value={bag.itemBag}>
//                                     {bag.itemBag}
//                                 </option>
//                             ))}
//                         </select>
//                         {errors.bag && <span className={styles.error}>{errors.bag}</span>}
//                     </div>
//                 </div>

//                 <div className={styles.row}>


//                     <div className={styles.inputGroup}>
//                         <label className={styles.inputLabel}>Item Quality</label>
//                         <select
//                             name="quantityLevel"
//                             className={styles.inputs}
//                             value={formData.quantityLevel}
//                             onChange={handleChange}
//                         >
//                             <option value="">Select Quantity</option>
//                             <option value="high">High</option>
//                             <option value="medium">Medium</option>
//                             <option value="low">Low</option>
//                         </select>
//                         {errors.quantityLevel && <span className={styles.error}>{errors.quantityLevel}</span>}
//                     </div>
//                        {formData.bag === 'kilogram' ? (
//                         <div className={styles.inputGroupFull}>
//                             <label className={styles.inputLabel}>Item Quantity (kg)</label>
//                             <input
//                                 name="quantity"
//                                 className={styles.input}
//                                 type="number"
//                                 placeholder="Enter Quantity"
//                                 value={formData.quantity}
//                                 onChange={handleChange}
//                             />
//                             {errors.quantity && <span className={styles.error}>{errors.quantity}</span>}
//                         </div>
//                     ) : (
//                         <div className={styles.inputGroupFull}>
//                             <label className={styles.inputLabel}>Item Count</label>
//                             <input
//                                 name="count"
//                                 className={styles.input}
//                                 type="number"
//                                 placeholder="Enter Count"
//                                 value={formData.count}
//                                 onChange={handleChange}
//                             />
//                             {errors.count && <span className={styles.error}>{errors.count}</span>}
//                         </div>
//                     )}
//                 </div>

//                 <div className={styles.row}>

//                 </div>

//                 <div className={styles.footerButtons}>
//                     <button type="button" className={styles.cancel} onClick={onClose}>Cancel</button>
//                     <button type="submit" className={styles.save}>
//                         {isEditMode ? "Update" : "Add"}
//                     </button>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default AddItemsPopup;


import React, { useEffect, useState, useCallback } from "react";
import styles from "../../assets/scss/InventoryManagement/AddItemsPopup.module.scss";
import { useGetItemBagsQuery, useGetItemcatQuery, useGetUserByIdQuery } from "../../slices/admin/admin";
//import WeightReader from "./WeightReader";
import WeightReaderManager from "../Billing/WeightReaderManager";
import { getUserInfo } from "../../utils/user.util";
import WeightReader from "../Billing/WeightReader";

// 🔄 Invisible live-weight subscriber
const LiveWeightSync = ({ onWeightChange }) => {
    useEffect(() => {
        const unsubscribe = WeightReaderManager.subscribe((val) => {
            if (val && !isNaN(val)) onWeightChange(val);
        });
        return unsubscribe;
    }, [onWeightChange]);
    return null;
};

const AddItemsPopup = ({ onClose, isEditMode = false, itemData = null }) => {
    const [itemImage, setItemImage] = useState(null);
    const [formData, setFormData] = useState({
        category: "",
        description: "",
        bag: "",
        quantityLevel: "",
        quality: "",
        quantity: "",
        count: "",
    });
    const [errors, setErrors] = useState({});
    const { data: bagData } = useGetItemBagsQuery();
    // const { data: catData } = useGetItemcatQuery();

    const localUser = getUserInfo();
    const userId = localUser?._id;
    const { data: userData } = useGetUserByIdQuery(userId, { skip: !userId });

    const storeObjectId = userData?.result?.[0]?.store?._id;


    const { data: catData } = useGetItemcatQuery(storeObjectId, {
        skip: !storeObjectId,
    });



    // ✅ Restore form data for edit mode
    useEffect(() => {
        if (itemData) {
            setFormData({
                category: itemData.category || "",
                description: itemData.description || "",
                bag: itemData.bag || "",
                quantityLevel: itemData.quantityLevel || "",
                quality: itemData.quality || "",
                quantity: itemData.quantity || "",
                count: itemData.count || "",
            });
        }
    }, [itemData]);

    // ✅ Weight machine data callback
    const handleWeightChange = useCallback((weightVal) => {
        setFormData((prev) => ({
            ...prev,
            quantity: Number(weightVal).toFixed(2),
        }));
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setItemImage(URL.createObjectURL(file));
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.category) newErrors.category = "Category is required";
        if (!formData.bag) newErrors.bag = "Bag is required";
        if (!formData.quantityLevel) newErrors.quantityLevel = "Quantity Level is required";
        if (formData.bag === "kilogram") {
            if (!formData.quantity) newErrors.quantity = "Quantity is required";
        } else {
            if (!formData.count) newErrors.count = "Count is required";
        }
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const storedItems = JSON.parse(localStorage.getItem("inventoryItems") || "[]");

        if (isEditMode && itemData?._id) {
            const updatedItems = storedItems.map((item) =>
                item._id === itemData._id ? { ...formData, _id: itemData._id } : item
            );
            localStorage.setItem("inventoryItems", JSON.stringify(updatedItems));
        } else {
            const newItem = { ...formData, _id: new Date().getTime().toString() };
            localStorage.setItem("inventoryItems", JSON.stringify([...storedItems, newItem]));
        }

        onClose();
    };

    return (
        <div className={styles.createOrdersContainers}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>{isEditMode ? "Edit Item" : "Add Item"}</h2>
                <span className={styles.closeIcon} onClick={onClose}>
                    ✕
                </span>
            </div>

            <form className={styles.formContainer} onSubmit={handleSubmit}>
                <div className={styles.row}>
                    {/* <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Item Category</label>
                        <select
                            name="category"
                            className={styles.inputs}
                            value={formData.category}
                            onChange={handleChange}
                        >
                            <option value="">Select Category</option>
                            {(catData?.getAllItems || []).map((cat) => (
                                <option key={cat._id} value={cat.itemCategory}>
                                    {cat.itemCategory}
                                </option>
                            ))}
                        </select>
                        {errors.category && <span className={styles.error}>{errors.category}</span>}
                    </div> */}
                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Item Category</label>

                        <select
                            name="category"
                            className={styles.inputs}
                            value={formData.category}
                            onChange={handleChange}
                        >
                            <option value="">Select Category</option>

                            {(catData?.items || []).map((cat) => (
                                <option key={cat._id} value={cat.itemCategory}>
                                    {cat.itemCategory}
                                </option>
                            ))}
                        </select>

                        {errors.category && (
                            <span className={styles.error}>{errors.category}</span>
                        )}
                    </div>


                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Item Scales</label>
                        <select
                            name="bag"
                            className={styles.inputs}
                            value={formData.bag}
                            onChange={handleChange}
                        >
                            <option value="">Select Bag</option>
                            {(bagData?.itemBags || []).map((bag) => (
                                <option key={bag._id} value={bag.itemBag}>
                                    {bag.itemBag}
                                </option>
                            ))}
                        </select>
                        {errors.bag && <span className={styles.error}>{errors.bag}</span>}
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Item Quality</label>
                        <select
                            name="quantityLevel"
                            className={styles.inputs}
                            value={formData.quantityLevel}
                            onChange={handleChange}
                        >
                            <option value="">Select Quantity</option>
                            <option value="high">High</option>
                            <option value="medium">Medium</option>
                            <option value="low">Low</option>
                        </select>
                        {errors.quantityLevel && (
                            <span className={styles.error}>{errors.quantityLevel}</span>
                        )}
                    </div>

                    {formData.bag === "kilogram" ? (
                        <div className={styles.inputGroupFull}>
                            <label className={styles.inputLabel}>Item Quantity (kg)</label>

                            {/* <input
                                name="quantity"
                                className={styles.input}
                                type="number"
                                placeholder="Live Weight"
                                value={formData.quantity}
                                onChange={handleChange}
                                readOnly={userData?.result?.[0]?.isRS232Enabled}
                            /> */}

                            <input
                                name="quantity"
                                className={styles.input}
                                type="number"
                                placeholder="Enter or wait for live weight"
                                value={formData.quantity}
                                onChange={handleChange}
                            />




                            {errors.quantity && <span className={styles.error}>{errors.quantity}</span>}
                        </div>
                    ) : (
                        <div className={styles.inputGroupFull}>
                            <label className={styles.inputLabel}>Item Count</label>
                            <input
                                name="count"
                                className={styles.input}
                                type="number"
                                placeholder="Enter Count"
                                value={formData.count}
                                onChange={handleChange}
                            />
                            {errors.count && <span className={styles.error}>{errors.count}</span>}
                        </div>
                    )}
                </div>

                <div className={styles.footerButtons}>
                    <div className={styles.weightReaderContainer}>
                        {/* ✅ Show live weight machine if enabled */}
                        {userData?.result?.[0]?.isRS232Enabled && (
                            <div className={styles.weightSection}>
                                <LiveWeightSync onWeightChange={handleWeightChange} />
                                <WeightReader />
                            </div>
                        )}

                    </div>
                    <div className={styles.buttonGroup}>
                        <button type="button" className={styles.cancel} onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className={styles.save}>
                            {isEditMode ? "Update" : "Add"}
                        </button>
                    </div>

                </div>
            </form>
        </div>
    );
};

export default AddItemsPopup;

